<div class="bw-block-legacy" [ngClass]="{'secondary': secondaryStyle, 'pointer': showPointer}" (click)="handleBlockAction($event)">
  <ng-content></ng-content>
</div>
